import React from 'react';
import styles from './SessionCard.module.scss';
import { parseUserAgent } from '../utils/parseUserAgent';
import { FaWindows, FaApple, FaLinux, FaAndroid, FaDesktop } from "react-icons/fa";

export interface SessionCardProps {
  session: Session;
  onSessionClick?: (session: Session) => void;
}

const SessionCard: React.FC<SessionCardProps> = ({ session, onSessionClick }) => {

  const getOsIcon = (os: string): [React.FC<{ size?: number; color?: string }>, string] => {
    let icon = FaDesktop;
    let color = "#424040"; // Cor padrão
    if (os.startsWith("Windows")) {
      icon = FaWindows
      color = "#00adef"
    } else if (os.startsWith("macOS") || os === "iOS") {
      icon = FaApple
      color = "#000000"
    } else if (os === "Linux") {
      icon = FaLinux
      color = "#FCC624"
    } else if (os === "Android") {
      icon = FaAndroid
      color = "#3DDC84"
    }
    return [icon as React.FC<{ size?: number; color?: string }>, color];
  }

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  const isExpired = session.revoked_at || new Date(session.expires_at) < new Date();
  const browserInfo = parseUserAgent(session.browser.user_agent);
  const [OsIcon, osColor] = getOsIcon(browserInfo.os);

  return (
    <div
      key={session.id}
      className={`${styles.userCard} ${isExpired ? styles.expired : ''}`}
      onClick={() => onSessionClick?.(session)}
    >
      <div className={styles.avatar}>
        <OsIcon size={24} color={osColor} />
      </div>
      <div className={styles.info}>
        <div className={styles.name}>
          {browserInfo.browser} ({browserInfo.os}) {isExpired ? '(Expirada/Revogada)' : ''}
        </div>
        <div className={styles.modified}>
          IP: {session.browser.ip}
        </div>
        <div className={styles.modified}>
          Login em: {formatDate(session.created_at)}
        </div>
        <div className={styles.modified}>
          Última atividade: {formatDate(session.logged_at)}
        </div>
        <div className={styles.modified}>
          Expira em: {formatDate(session.expires_at)}
        </div>
        {session.revoked_at && (
          <div className={styles.modified}>
            Revogada em: {formatDate(session.revoked_at)}
          </div>
        )}
      </div>
    </div>
  );
};

export default SessionCard;
